import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { WorkingMode } from "@/model/baseTypes";
import { asReadonly } from "@/utils/vue";

import { useClientSettingsStore } from "./clientSettings";

export const useWorkModeStore = defineStore("workMode", () => {
  const workingMode = ref<WorkingMode>("planning");

  return {
    workingMode: asReadonly(workingMode),

    isExecutionMode: computed(() => workingMode.value === "execution"),
    isPlanningMode: computed(() => workingMode.value === "planning"),

    setWorkingMode: (mode: WorkingMode) => {
      workingMode.value = mode;
      useClientSettingsStore().setWorkingMode(workingMode.value);
    },
    toggle: () => {
      workingMode.value = workingMode.value === "execution" ? "planning" : "execution";
      useClientSettingsStore().setWorkingMode(workingMode.value);
    },
  };
});
